// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.employee-form-container {
  width: 100%;
  max-width: 400px;
  margin: 50px auto;
  padding: 20px;
  background: #ffffff;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  text-align: center;
}

.employee-form h2 {
  margin-bottom: 20px;
  color: #333;
}

.form-group {
  margin-bottom: 15px;
  text-align: left;
}

label {
  display: block;
  margin-bottom: 5px;
  font-weight: bold;
  color: #555;
}

.employee-form input {
  width: 100%;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  font-size: 16px;
}

.submit-btn {
  width: 100%;
  padding: 10px;
  background: #007bff;
  color: white;
  border: none;
  border-radius: 5px;
  font-size: 16px;
  cursor: pointer;
  margin-top: 10px;
}

.submit-btn:hover {
  background: #0056b3;
}

.employee_table_container {
  width: 90%;
  margin: auto;
  text-align: center;
}

.employee_table_container h2 {
  color: #333;
  margin-bottom: 20px;
}

.employee_table {
  width: 100%;
  border-collapse: collapse;
  background: #fff;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  overflow: hidden;
}

.employee_table th,
.employee_table td {
  padding: 12px;
  border: 1px solid #ddd;
  text-align: left;
}

.employee_table th {
  background-color: #007bff;
  color: white;
}

.employee_table tr:nth-child(even) {
  background-color: #f2f2f2;
}

.employee_table tr:hover {
  background-color: #ddd;
}

.employe_delete_btn {
  background-color: red;
  color: white;
  border: none;
  padding: 8px 12px;
  cursor: pointer;
  border-radius: 5px;
}

.employe_delete_btn:hover {
  background-color: darkred;
}

@media screen and (max-width: 768px) {
  .employee_table {
    display: block;
    width: 100%;
    overflow: auto;
  }

  .employee_table tr {
    margin-bottom: 10px;
    border-bottom: 2px solid #ddd;
  }

  .employee_table td {
    /* padding-left: 100%; */
    position: relative;
    text-align: right;
  }

  .employe_delete_btn {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Registration/employeregister.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,2CAA2C;EAC3C,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,uCAAuC;EACvC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,cAAc;IACd,WAAW;IACX,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,6BAA6B;EAC/B;;EAEA;IACE,wBAAwB;IACxB,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":[".employee-form-container {\n  width: 100%;\n  max-width: 400px;\n  margin: 50px auto;\n  padding: 20px;\n  background: #ffffff;\n  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);\n  border-radius: 8px;\n  text-align: center;\n}\n\n.employee-form h2 {\n  margin-bottom: 20px;\n  color: #333;\n}\n\n.form-group {\n  margin-bottom: 15px;\n  text-align: left;\n}\n\nlabel {\n  display: block;\n  margin-bottom: 5px;\n  font-weight: bold;\n  color: #555;\n}\n\n.employee-form input {\n  width: 100%;\n  padding: 10px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  font-size: 16px;\n}\n\n.submit-btn {\n  width: 100%;\n  padding: 10px;\n  background: #007bff;\n  color: white;\n  border: none;\n  border-radius: 5px;\n  font-size: 16px;\n  cursor: pointer;\n  margin-top: 10px;\n}\n\n.submit-btn:hover {\n  background: #0056b3;\n}\n\n.employee_table_container {\n  width: 90%;\n  margin: auto;\n  text-align: center;\n}\n\n.employee_table_container h2 {\n  color: #333;\n  margin-bottom: 20px;\n}\n\n.employee_table {\n  width: 100%;\n  border-collapse: collapse;\n  background: #fff;\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n  border-radius: 10px;\n  overflow: hidden;\n}\n\n.employee_table th,\n.employee_table td {\n  padding: 12px;\n  border: 1px solid #ddd;\n  text-align: left;\n}\n\n.employee_table th {\n  background-color: #007bff;\n  color: white;\n}\n\n.employee_table tr:nth-child(even) {\n  background-color: #f2f2f2;\n}\n\n.employee_table tr:hover {\n  background-color: #ddd;\n}\n\n.employe_delete_btn {\n  background-color: red;\n  color: white;\n  border: none;\n  padding: 8px 12px;\n  cursor: pointer;\n  border-radius: 5px;\n}\n\n.employe_delete_btn:hover {\n  background-color: darkred;\n}\n\n@media screen and (max-width: 768px) {\n  .employee_table {\n    display: block;\n    width: 100%;\n    overflow: auto;\n  }\n\n  .employee_table tr {\n    margin-bottom: 10px;\n    border-bottom: 2px solid #ddd;\n  }\n\n  .employee_table td {\n    /* padding-left: 100%; */\n    position: relative;\n    text-align: right;\n  }\n\n  .employe_delete_btn {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
